"use client";

import { useId, useState } from "react";
import type { ProfileQuestion } from "@/lib/seo/profile-facts";
import { CARD_SHELL_STYLE } from "./profile-card-style";

function Answer({ item }: { item: ProfileQuestion }) {
  const [expanded, setExpanded] = useState(false);
  const id = useId();
  return <div className="border-t py-4" style={{ borderColor: "var(--brand-card-border)" }}>
    <h3><button type="button" aria-expanded={expanded} aria-controls={id}
      onClick={() => setExpanded(!expanded)}
      className="w-full cursor-pointer rounded text-left font-medium focus-visible:outline-2 focus-visible:outline-offset-4"
      style={{ color: "var(--brand-text)" }}>{item.question}</button></h3>
    <p id={id} hidden={!expanded} className="mt-3 text-sm leading-relaxed" style={{ color: "var(--brand-text-muted)" }}>{item.answer}</p>
  </div>;
}

export function ProfileFaq({ questions }: { questions: ProfileQuestion[] }) {
  if (!questions.length) return null;
  return <section aria-label="Profile questions" className="p-6 sm:p-8" style={CARD_SHELL_STYLE}>
    <h2 className="mb-4 text-lg font-semibold" style={{ color: "var(--brand-text)", fontFamily: "var(--brand-font-heading)" }}>Profile questions</h2>
    {questions.map((item) => <Answer key={item.question} item={item} />)}
  </section>;
}
